// // // import React, { useState } from 'react';
// // // import { useNavigate } from 'react-router-dom';
// // // import { loginUser } from '../../services/apiService';
// // // import {
// // //   Box,
// // //   Button,
// // //   Container,
// // //   TextField,
// // //   Typography,
// // //   Alert,
// // //   Paper
// // // } from '@mui/material';

// // // const LoginPage = () => {
// // //   const [email, setEmail] = useState('');
// // //   const [password, setPassword] = useState('');
// // //   const [error, setError] = useState('');
// // //   const navigate = useNavigate();

// // // const handleLogin = async () => {
// // //   try {
// // //     const response = await loginUser({ email, password });
// // //     const { token, user } = response;
// // //     const role = user.role;

// // //     localStorage.setItem('token', token);
// // //     localStorage.setItem('role', role);
// // //     localStorage.setItem('user', JSON.stringify(user)); // optional

// // //     if (role === 'admin') {
// // //       navigate('/dashboard');
// // //     } else if (role === 'reporter') {
// // //       navigate('/reporter-dashboard');
// // //     } 
// // //      else if (role === 'superadmin') {
// // //       navigate('/superadmin-dashboard');
// // //     }else {
// // //       setError('Invalid role received from server.');
// // //     }
// // //   } catch (err) {
// // //     setError('Login failed. Please check your credentials.');
// // //   }
// // // };


// // //   return (
// // //     <Container maxWidth="sm">
// // //       <Paper elevation={3} sx={{ p: 4, mt: 8, borderRadius: 2 }}>
// // //         <Typography variant="h5" gutterBottom align="center">
// // //           Login to EWS News
// // //         </Typography>

// // //         <Box component="form" noValidate autoComplete="off" sx={{ mt: 2 }}>
// // //           <TextField
// // //             fullWidth
// // //             type="email"
// // //             label="Email"
// // //             variant="outlined"
// // //             margin="normal"
// // //             value={email}
// // //             onChange={(e) => setEmail(e.target.value)}
// // //           />

// // //           <TextField
// // //             fullWidth
// // //             type="password"
// // //             label="Password"
// // //             variant="outlined"
// // //             margin="normal"
// // //             value={password}
// // //             onChange={(e) => setPassword(e.target.value)}
// // //           />

// // //           {error && (
// // //             <Alert severity="error" sx={{ mt: 2 }}>
// // //               {error}
// // //             </Alert>
// // //           )}

// // //           <Button
// // //             fullWidth
// // //             variant="contained"
// // //             color="primary"
// // //             onClick={handleLogin}
// // //             sx={{ mt: 3 }}
// // //           >
// // //             Login
// // //           </Button>
// // //         </Box>
// // //       </Paper>
// // //     </Container>
// // //   );
// // // };

// // // export default LoginPage;

// // import React, { useState } from 'react';
// // import { useNavigate } from 'react-router-dom';
// // import { loginUser } from '../../services/apiService';
// // import {
// //   Box,
// //   Button,
// //   Container,
// //   TextField,
// //   Typography,
// //   Alert,
// //   Paper,
// //   InputAdornment,
// //   IconButton,
// //   CircularProgress,
// //   Link,
// //   Divider,
// //   useTheme,
// //   alpha
// // } from '@mui/material';
// // import {
// //   Visibility,
// //   VisibilityOff,
// //   Email,
// //   Lock,
// //   Login as LoginIcon
// // } from '@mui/icons-material';

// // const LoginPage = () => {
// //   const [formData, setFormData] = useState({
// //     email: '',
// //     password: ''
// //   });
// //   const [showPassword, setShowPassword] = useState(false);
// //   const [error, setError] = useState('');
// //   const [isLoading, setIsLoading] = useState(false);
// //   const navigate = useNavigate();
// //   const theme = useTheme();

// //   const handleInputChange = (field) => (event) => {
// //     setFormData(prev => ({
// //       ...prev,
// //       [field]: event.target.value
// //     }));
// //     // Clear error when user starts typing
// //     if (error) setError('');
// //   };

// //   const handleTogglePasswordVisibility = () => {
// //     setShowPassword(prev => !prev);
// //   };

// //   const validateForm = () => {
// //     if (!formData.email || !formData.password) {
// //       setError('Please fill in all fields');
// //       return false;
// //     }
    
// //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// //     if (!emailRegex.test(formData.email)) {
// //       setError('Please enter a valid email address');
// //       return false;
// //     }
    
// //     return true;
// //   };

// //   const handleLogin = async (event) => {
// //     event.preventDefault();
    
// //     if (!validateForm()) return;

// //     setIsLoading(true);
// //     setError('');

// //     try {
// //       const response = await loginUser({
// //         email: formData.email,
// //         password: formData.password
// //       });
      
// //       const { token, user } = response;
// //       const role = user.role;

// //       // Store user data
// //       localStorage.setItem('token', token);
// //       localStorage.setItem('role', role);
// //       localStorage.setItem('user', JSON.stringify(user));

// //       // Navigate based on role
// //       const roleRoutes = {
// //         admin: '/dashboard',
// //         reporter: '/reporter-dashboard',
// //         superadmin: '/superadmin-dashboard'
// //       };

// //       if (roleRoutes[role]) {
// //         navigate(roleRoutes[role]);
// //       } else {
// //         setError('Invalid role received from server.');
// //       }
// //     } catch (err) {
// //       setError(
// //         err.response?.data?.message || 
// //         'Login failed. Please check your credentials.'
// //       );
// //     } finally {
// //       setIsLoading(false);
// //     }
// //   };

// //   const handleKeyPress = (event) => {
// //     if (event.key === 'Enter') {
// //       handleLogin(event);
// //     }
// //   };

// //   return (
// //     <Container maxWidth="sm">
// //       <Box
// //         sx={{
// //           minHeight: '100vh',
// //           display: 'flex',
// //           alignItems: 'center',
// //           justifyContent: 'center',
// //           py: 3
// //         }}
// //       >
// //         <Paper
// //           elevation={8}
// //           sx={{
// //             p: { xs: 3, sm: 4 },
// //             borderRadius: 3,
// //             width: '100%',
// //             background: `linear-gradient(135deg, ${alpha(theme.palette.primary.light, 0.1)} 0%, ${alpha(theme.palette.background.paper, 1)} 100%)`,
// //             backdropFilter: 'blur(10px)',
// //             border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`
// //           }}
// //         >
// //           {/* Header Section */}
// //           <Box sx={{ textAlign: 'center', mb: 4 }}>
// //             <Typography
// //               variant="h4"
// //               component="h1"
// //               gutterBottom
// //               sx={{
// //                 fontWeight: 'bold',
// //                 color: theme.palette.primary.main,
// //                 mb: 1
// //               }}
// //             >
// //               EMS News
// //             </Typography>
// //             <Typography
// //               variant="body1"
// //               color="text.secondary"
// //               sx={{ mb: 2 }}
// //             >
// //               Welcome back! Please sign in to your account
// //             </Typography>
// //             <Divider sx={{ width: '60%', mx: 'auto' }} />
// //           </Box>

// //           {/* Login Form */}
// //           <Box
// //             component="form"
// //             onSubmit={handleLogin}
// //             noValidate
// //             sx={{ width: '100%' }}
// //           >
// //             <TextField
// //               fullWidth
// //               type="email"
// //               label="Email Address"
// //               variant="outlined"
// //               margin="normal"
// //               value={formData.email}
// //               onChange={handleInputChange('email')}
// //               onKeyPress={handleKeyPress}
// //               disabled={isLoading}
// //               InputProps={{
// //                 startAdornment: (
// //                   <InputAdornment position="start">
// //                     <Email color="action" />
// //                   </InputAdornment>
// //                 ),
// //               }}
// //               sx={{
// //                 '& .MuiOutlinedInput-root': {
// //                   borderRadius: 2,
// //                   transition: 'all 0.3s ease-in-out',
// //                   '&:hover': {
// //                     '& .MuiOutlinedInput-notchedOutline': {
// //                       borderColor: theme.palette.primary.main,
// //                     },
// //                   },
// //                 },
// //               }}
// //             />

// //             <TextField
// //               fullWidth
// //               type={showPassword ? 'text' : 'password'}
// //               label="Password"
// //               variant="outlined"
// //               margin="normal"
// //               value={formData.password}
// //               onChange={handleInputChange('password')}
// //               onKeyPress={handleKeyPress}
// //               disabled={isLoading}
// //               InputProps={{
// //                 startAdornment: (
// //                   <InputAdornment position="start">
// //                     <Lock color="action" />
// //                   </InputAdornment>
// //                 ),
// //                 endAdornment: (
// //                   <InputAdornment position="end">
// //                     <IconButton
// //                       aria-label="toggle password visibility"
// //                       onClick={handleTogglePasswordVisibility}
// //                       edge="end"
// //                       disabled={isLoading}
// //                     >
// //                       {showPassword ? <VisibilityOff /> : <Visibility />}
// //                     </IconButton>
// //                   </InputAdornment>
// //                 ),
// //               }}
// //               sx={{
// //                 '& .MuiOutlinedInput-root': {
// //                   borderRadius: 2,
// //                   transition: 'all 0.3s ease-in-out',
// //                   '&:hover': {
// //                     '& .MuiOutlinedInput-notchedOutline': {
// //                       borderColor: theme.palette.primary.main,
// //                     },
// //                   },
// //                 },
// //               }}
// //             />

// //             {/* Error Alert */}
// //             {error && (
// //               <Alert
// //                 severity="error"
// //                 sx={{
// //                   mt: 2,
// //                   borderRadius: 2,
// //                   '& .MuiAlert-message': {
// //                     width: '100%'
// //                   }
// //                 }}
// //                 onClose={() => setError('')}
// //               >
// //                 {error}
// //               </Alert>
// //             )}

// //             {/* Login Button */}
// //             <Button
// //               fullWidth
// //               variant="contained"
// //               type="submit"
// //               disabled={isLoading}
// //               startIcon={
// //                 isLoading ? (
// //                   <CircularProgress size={20} color="inherit" />
// //                 ) : (
// //                   <LoginIcon />
// //                 )
// //               }
// //               sx={{
// //                 mt: 3,
// //                 mb: 2,
// //                 py: 1.5,
// //                 borderRadius: 2,
// //                 fontSize: '1.1rem',
// //                 fontWeight: 'bold',
// //                 textTransform: 'none',
// //                 background: `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.primary.dark} 90%)`,
// //                 boxShadow: `0 3px 5px 2px ${alpha(theme.palette.primary.main, 0.3)}`,
// //                 transition: 'all 0.3s ease-in-out',
// //                 '&:hover': {
// //                   transform: 'translateY(-2px)',
// //                   boxShadow: `0 6px 10px 4px ${alpha(theme.palette.primary.main, 0.3)}`,
// //                 },
// //                 '&:disabled': {
// //                   background: theme.palette.action.disabled,
// //                   transform: 'none',
// //                   boxShadow: 'none',
// //                 },
// //               }}
// //             >
// //               {isLoading ? 'Signing In...' : 'Sign In'}
// //             </Button>

// //             {/* Additional Links
// //             <Box sx={{ textAlign: 'center', mt: 2 }}>
// //               <Link
// //                 href="#"
// //                 variant="body2"
// //                 color="primary"
// //                 sx={{
// //                   textDecoration: 'none',
// //                   '&:hover': {
// //                     textDecoration: 'underline',
// //                   },
// //                 }}
// //               >
// //                 Forgot your password?
// //               </Link>
// //             </Box> */}

          
// //           </Box>
// //         </Paper>
// //       </Box>
// //     </Container>
// //   );
// // };

// // export default LoginPage;

// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { loginUser } from '../../services/apiService';

// const LoginPage = () => {
//   const [formData, setFormData] = useState({
//     email: '',
//     password: ''
//   });
//   const [showPassword, setShowPassword] = useState(false);
//   const [error, setError] = useState('');
//   const [isLoading, setIsLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleInputChange = (field) => (event) => {
//     setFormData(prev => ({
//       ...prev,
//       [field]: event.target.value
//     }));
//     if (error) setError('');
//   };

//   const validateForm = () => {
//     if (!formData.email || !formData.password) {
//       setError('Please fill in all fields');
//       return false;
//     }

//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(formData.email)) {
//       setError('Please enter a valid email address');
//       return false;
//     }

//     return true;
//   };

//   const handleLogin = async (event) => {
//     event.preventDefault();

//     if (!validateForm()) return;

//     setIsLoading(true);
//     setError('');

//     try {
//       const response = await loginUser({
//         email: formData.email,
//         password: formData.password
//       });

//       const { token, user } = response;
//       const role = user.role;

//       localStorage.setItem('token', token);
//       localStorage.setItem('role', role);
//       localStorage.setItem('user', JSON.stringify(user));

//       const roleRoutes = {
//         admin: '/dashboard',
//         reporter: '/reporter-dashboard',
//         superadmin: '/superadmin-dashboard'
//       };

//       if (roleRoutes[role]) {
//         navigate(roleRoutes[role]);
//       } else {
//         setError('Invalid role received from server.');
//       }
//     } catch (err) {
//       setError(
//         err.response?.data?.message ||
//         'Login failed. Please check your credentials.'
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-900 via-indigo-950 to-slate-900 px-4 py-10 relative overflow-hidden">
//       {/* Background glow effects */}
//       <div className="absolute top-0 -left-20 w-96 h-96 bg-indigo-600/30 rounded-full blur-3xl"></div>
//       <div className="absolute bottom-0 -right-20 w-96 h-96 bg-purple-600/30 rounded-full blur-3xl"></div>

//       <div className="relative w-full max-w-md">
//         <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl shadow-2xl p-8 sm:p-10">

//           {/* Header */}
//           <div className="text-center mb-8">
//             <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-white/10 backdrop-blur mb-4 shadow-lg shadow-indigo-500/30 p-2">
//               <img
//                 src="/logo1.png"
//                 alt="EMS News Logo"
//                 className="w-full h-full object-contain"
//               />
//             </div>
//             <h1 className="text-3xl font-bold text-white tracking-tight">EMS News</h1>
//             <p className="text-slate-300 mt-2 text-sm">Welcome back! Please sign in to your account</p>
//           </div>

//           {/* Form */}
//           <form onSubmit={handleLogin} className="space-y-5">

//             {/* Email */}
//             <div>
//               <label className="block text-sm font-medium text-slate-200 mb-1.5">
//                 Email Address
//               </label>
//               <div className="relative">
//                 <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
//                   <svg className="w-5 h-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
//                     <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
//                   </svg>
//                 </div>
//                 <input
//                   type="email"
//                   value={formData.email}
//                   onChange={handleInputChange('email')}
//                   disabled={isLoading}
//                   placeholder="you@example.com"
//                   className="w-full pl-11 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all disabled:opacity-50"
//                 />
//               </div>
//             </div>

//             {/* Password */}
//             <div>
//               <label className="block text-sm font-medium text-slate-200 mb-1.5">
//                 Password
//               </label>
//               <div className="relative">
//                 <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
//                   <svg className="w-5 h-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
//                     <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
//                   </svg>
//                 </div>
//                 <input
//                   type={showPassword ? 'text' : 'password'}
//                   value={formData.password}
//                   onChange={handleInputChange('password')}
//                   disabled={isLoading}
//                   placeholder="••••••••"
//                   className="w-full pl-11 pr-11 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all disabled:opacity-50"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShowPassword(prev => !prev)}
//                   disabled={isLoading}
//                   className="absolute inset-y-0 right-0 pr-3.5 flex items-center text-slate-400 hover:text-slate-200 transition-colors"
//                 >
//                   {showPassword ? (
//                     <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
//                       <path strokeLinecap="round" strokeLinejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.542-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.243M9.878 9.878L3 3m6.878 6.878L21 21" />
//                     </svg>
//                   ) : (
//                     <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
//                       <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//                       <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                     </svg>
//                   )}
//                 </button>
//               </div>
//             </div>

//             {/* Error */}
//             {error && (
//               <div className="flex items-start gap-2 bg-red-500/10 border border-red-500/30 text-red-300 text-sm rounded-xl px-4 py-3 animate-[fadeIn_0.2s_ease-in]">
//                 <svg className="w-5 h-5 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
//                   <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                 </svg>
//                 <span>{error}</span>
//               </div>
//             )}

//             {/* Submit */}
//             <button
//               type="submit"
//               disabled={isLoading}
//               className="w-full flex items-center justify-center gap-2 py-3.5 rounded-xl font-semibold text-white bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 shadow-lg shadow-indigo-500/30 hover:shadow-indigo-500/50 transition-all duration-200 hover:-translate-y-0.5 disabled:opacity-60 disabled:hover:translate-y-0 disabled:cursor-not-allowed"
//             >
//               {isLoading ? (
//                 <>
//                   <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24" fill="none">
//                     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
//                   </svg>
//                   Signing In...
//                 </>
//               ) : (
//                 <>
//                   <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
//                     <path strokeLinecap="round" strokeLinejoin="round" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
//                   </svg>
//                   Sign In
//                 </>
//               )}
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;



import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../../services/apiService';

const LoginPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (field) => (event) => {
    setFormData(prev => ({
      ...prev,
      [field]: event.target.value
    }));
    if (error) setError('');
  };

  const validateForm = () => {
    if (!formData.email || !formData.password) {
      setError('Please fill in all fields');
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError('Please enter a valid email address');
      return false;
    }

    return true;
  };

  const handleLogin = async (event) => {
    event.preventDefault();

    if (!validateForm()) return;

    setIsLoading(true);
    setError('');

    try {
      const response = await loginUser({
        email: formData.email,
        password: formData.password
      });

      const { token, user } = response;
      const role = user.role;

      localStorage.setItem('token', token);
      localStorage.setItem('role', role);
      localStorage.setItem('user', JSON.stringify(user));

      const roleRoutes = {
        admin: '/dashboard',
        reporter: '/reporter-dashboard',
        superadmin: '/superadmin-dashboard'
      };

      if (roleRoutes[role]) {
        navigate(roleRoutes[role]);
      } else {
        setError('Invalid role received from server.');
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
        'Login failed. Please check your credentials.'
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-50 via-indigo-50 to-slate-100 px-4 py-10 relative overflow-hidden">
      {/* Background glow effects */}
      <div className="absolute top-0 -left-20 w-96 h-96 bg-[#32A5D6]/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 -right-20 w-96 h-96 bg-[#BD1723]/25 rounded-full blur-3xl"></div>

      <div className="relative w-full max-w-md">
        <div className="bg-gradient-to-br from-white via-[#32A5D6]/5 to-[#BD1723]/5 backdrop-blur-xl border border-[#32A5D6]/20 rounded-2xl shadow-2xl shadow-[#32A5D6]/20 p-8 sm:p-10">

          {/* Header */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-white shadow-lg shadow-indigo-200/50 mb-4 p-2">
              <img
                src="/logo1.png"
                alt="EMS News Logo"
                className="w-full h-full object-contain"
              />
            </div>
            <h1 className="text-3xl font-bold text-slate-900 tracking-tight">EMS News</h1>
            <p className="text-slate-500 mt-2 text-sm">Welcome back! Please sign in to your account</p>
          </div>

          {/* Form */}
          <form onSubmit={handleLogin} className="space-y-5">

            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">
                Email Address
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                  <svg className="w-5 h-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <input
                  type="email"
                  value={formData.email}
                  onChange={handleInputChange('email')}
                  disabled={isLoading}
                  placeholder="you@example.com"
                  className="w-full pl-11 pr-4 py-3 rounded-xl bg-slate-50 border border-slate-200 text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-[#32A5D6] focus:border-transparent transition-all disabled:opacity-50"
                />
              </div>
            </div>

            {/* Password */}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">
                Password
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                  <svg className="w-5 h-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                </div>
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={formData.password}
                  onChange={handleInputChange('password')}
                  disabled={isLoading}
                  placeholder="••••••••"
                  className="w-full pl-11 pr-11 py-3 rounded-xl bg-slate-50 border border-slate-200 text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-[#32A5D6] focus:border-transparent transition-all disabled:opacity-50"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(prev => !prev)}
                  disabled={isLoading}
                  className="absolute inset-y-0 right-0 pr-3.5 flex items-center text-slate-400 hover:text-slate-600 transition-colors"
                >
                  {showPassword ? (
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.542-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.243M9.878 9.878L3 3m6.878 6.878L21 21" />
                    </svg>
                  ) : (
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {/* Error */}
            {error && (
              <div className="flex items-start gap-2 bg-red-50 border border-red-200 text-red-600 text-sm rounded-xl px-4 py-3 animate-[fadeIn_0.2s_ease-in]">
                <svg className="w-5 h-5 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>{error}</span>
              </div>
            )}

            {/* Submit */}
            <button
              type="submit"
              disabled={isLoading}
              className="w-full flex items-center justify-center gap-2 py-3.5 rounded-xl font-semibold text-white bg-gradient-to-r from-[#32A5D6] to-[#BD1723] hover:brightness-110 shadow-lg shadow-[#32A5D6]/30 hover:shadow-[#BD1723]/40 transition-all duration-200 hover:-translate-y-0.5 disabled:opacity-60 disabled:hover:translate-y-0 disabled:cursor-not-allowed"
            >
              {isLoading ? (
                <>
                  <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24" fill="none">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                  </svg>
                  Signing In...
                </>
              ) : (
                <>
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                  </svg>
                  Sign In
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;